module.exports = __webpack_public_path__ + "img/Operatore-edifici-JS-029.c941a544.jpg";